import { useRecoilValue } from 'recoil';

import { ModifierGroup } from '../ModifierGroup';
import { modifierGroupsState, activeModifierGroupState } from '../../atoms';

export const ModifierGroups: React.FC = () => {
	const modifierGroupModel = useRecoilValue(modifierGroupsState);
	const activeModifierGroup = useRecoilValue(activeModifierGroupState);

	if (!modifierGroupModel) {
		return <></>;
	}

	return (
		<div className="product-modifier-groups">
			{modifierGroupModel.modifierGroups
				.map((modifierGroup, index) => ({
					...modifierGroup,
					index
				}))
				.sort((a, b) => a.priority - b.priority)
				.map((modifierGroup, index) => (
					<ModifierGroup
						key={index}
						modifierGroupIndex={modifierGroup.index}
						isActive={modifierGroup.index === activeModifierGroup}
						modifierGroup={modifierGroup}
						modifierModel={
							modifierGroupModel.modifierModels[
								modifierGroup.index
							]
						}
					/>
				))}
		</div>
	);
};
